import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import Response from "../response";
import { errCodes } from "../response/errors";
import { BLITZ_CI_AUTH } from "../../utils/constants";
import { delay } from "../../utils/timer";
import DataService from "../data";

class Auth {
  constructor(app) {
    this.auth = getAuth(app);
  }

  async login(email, password) {
    try {
      const credentials = await signInWithEmailAndPassword(
        this.auth,
        email,
        password
      );
      const user = credentials.user;

      const accessToken = user.accessToken;
      await this.#saveAccessToken(accessToken);

      const verifyUserDataResponse = await DataService.Users.verifyUserData(
        user.uid
      );

      if (!verifyUserDataResponse.success) {
        await this.#saveAccessToken("");
        return Response.create(
          {},
          verifyUserDataResponse.success,
          verifyUserDataResponse.error,
          verifyUserDataResponse.code
        );
      }

      return Response.create({}, true);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async signup(email, password, userData) {
    try {
      const credentials = await createUserWithEmailAndPassword(this.auth, email, password);
      const user = credentials.user;

      const createUserResponse = await DataService.Users.createUserData(user.uid, userData)
      if (!createUserResponse.success) {
        return Response.create(
          {},
          createUserResponse.success,
          createUserResponse.error,
          createUserResponse.code
        );
      }

      const accessToken = user.accessToken;
      await this.#saveAccessToken(accessToken);

      return Response.create({}, true);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async #saveAccessToken(accessToken) {
    sessionStorage.setItem(BLITZ_CI_AUTH, accessToken);

    await delay(3000);
  }
}

export default Auth;
